<new-flowbanner [showPromo]="true"></new-flowbanner>
<div class="pt-5 py-lg-5 validacion-error-container">
    <div class="row justify-content-center me-0">
        <div class="col-12 col-md-8 col-lg-6 d-flex flex-column align-items-center text-center">
            <h2 class="validacion-error-title mb-4">Cotización en pausa</h2>

            <p class="validacion-error-text mb-3">
                Ocurrió un error en la validación de tu información.
                <span class="validacion-error-text-highlight">¡No te preocupes, ya tenemos tus datos!</span>
            </p>

            <p class="validacion-error-subtitle mb-5">
                Nos pondremos en contacto contigo en la próxima hora ;)
            </p>

            <button
                type="button"
                class="btn btn-primary btn-lg rounded-pill validacion-error-btn mt-lg-3 mt-2 mb-5"
                (click)="enviar()">
                Enviar
            </button>
        </div>
    </div>
</div>

<app-footer-app></app-footer-app>
